import { resolvePublicAssetUrl } from '@/utils/resolvePublicAssetUrl'
import { cn } from '@/utils/cn'
import type {
  FinanceAssignee,
  FinanceRequestDetail,
} from '@/services/financeService'
import { FinanceRequestCommentsPanel } from './FinanceRequestCommentsPanel'
import { FinanceRequestFormFields } from './FinanceRequestFormFields'
import { FinanceRequestQueuePanel } from './FinanceRequestQueuePanel'

type Props = {
  detail: FinanceRequestDetail
  canManageQueue: boolean
  assignees: FinanceAssignee[]
  layout?: 'drawer' | 'portal'
  onUpdateStatus: (status: string, approvalPendingFrom?: string) => Promise<boolean>
  onAssign: (assigneeId: string | null) => Promise<boolean>
  onAddComment: (body: string, isInternal?: boolean, attachments?: string[]) => Promise<boolean>
}

export function FinanceRequestDetailBody({
  detail,
  canManageQueue,
  assignees,
  layout = 'drawer',
  onUpdateStatus,
  onAssign,
  onAddComment,
}: Props) {
  const isPortal = layout === 'portal'
  const formData =
    detail.formData && typeof detail.formData === 'object'
      ? (detail.formData as unknown as Record<string, unknown>)
      : null

  return (
    <div className='space-y-6'>
      <FinanceRequestQueuePanel
        detail={detail}
        canManageQueue={canManageQueue}
        assignees={assignees}
        onUpdateStatus={onUpdateStatus}
        onAssign={onAssign}
      />

      {formData && (
        <FinanceRequestFormFields formData={formData} />
      )}

      {detail.attachments?.length > 0 && (
        <section>
          <h3 className='mb-2 text-sm font-semibold text-text-primary'>Anexos</h3>
          <ul className='space-y-2 rounded-lg border border-border bg-bg-secondary p-3 text-sm'>
            {detail.attachments.map((url) => (
              <li key={url}>
                <a
                  href={resolvePublicAssetUrl(url)}
                  target='_blank'
                  rel='noreferrer'
                  className='text-accent hover:underline'
                >
                  {url.split('/').pop() ?? 'Arquivo'}
                </a>
              </li>
            ))}
          </ul>
        </section>
      )}

      <section className={cn(isPortal && 'rounded-2xl border border-border/70 bg-bg-secondary/40 p-4')}>
        <h3 className='mb-3 text-sm font-semibold text-text-primary'>Comentários</h3>
        <FinanceRequestCommentsPanel
          detail={detail}
          canManageQueue={canManageQueue}
          onAddComment={onAddComment}
        />
      </section>
    </div>
  )
}
